import { Injectable } from '@angular/core';
import { PassengerType } from '../../core/enums/passenger-type.enum';
import { PriceRate } from '../../core/models/price-rate';
import { PriceRateDescriptor } from '../../core/enums/price-rate-descriptor.enum';
import { PriceRateService } from '../../modules/searcher/services/price-rate.service';


@Injectable({
  providedIn: 'root',
})
export class AirTicketService {
  constructor(private priceRateService: PriceRateService) {}

  public getAirTicketPrice(passengerType: PassengerType): number {
    try {
      if (passengerType === PassengerType.CHILD) {
        return this.getChildrenAirTicketPrice();
      } else {
        return this.getAdultsAirTicketPrice();
      }
    } catch (error) {
      console.log('AirTicketService.getChildrenAirTicketPrice()');
      console.error(error);
      throw error;
    }
  }

  private getAdultsAirTicketPrice(): number {
    try {
      const priceRate: PriceRate | undefined =
        this.getAdultsAirTicketPriceRate();
      if (this.isNullOrUndefined(priceRate)) {
        throw new Error();
      }
      return priceRate ? priceRate.valor : 500;
    } catch (error) {
      console.log('AirTicketService.getAdultsAirTicketPrice()');
      console.error(error);
      throw error;
    }
  }

  private getChildrenAirTicketPrice(): number {
    try {
      const priceRate: PriceRate | undefined =
        this.getChildrenAirTicketPriceRate();
      if (this.isNullOrUndefined(priceRate)) {
        throw new Error();
      }
      return priceRate ? priceRate.valor : 350;
    } catch (error) {
      console.log('AirTicketService.getChildrenAirTicketPrice()');
      console.error(error);
      throw error;
    }
  }

  private getChildrenAirTicketPriceRate(): PriceRate | undefined {
    try {
      return this.priceRateService.getPriceRateByName(
        PriceRateDescriptor.ChildrenAirFare
      );
    } catch (error) {
      console.log('AirTicketService.getChildrenAirTicketPriceRate()');
      console.error(error);
      return undefined;
    }
  }

  private getAdultsAirTicketPriceRate(): PriceRate | undefined {
    try {
      return this.priceRateService.getPriceRateByName(
        PriceRateDescriptor.AirFare
      );
    } catch (error) {
      console.log('AirTicketService.getAdultsAirTicketPriceRate()');
      console.error(error);
      return undefined;
    }
  }
  isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }
}
